import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";

export function Input({ className, type = "text", ...props }: ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "min-h-12 w-full rounded-chip border border-border bg-surface px-4 text-base text-ink",
        "placeholder:text-muted focus-visible:border-accent focus-visible:outline-2 focus-visible:outline-accent/30",
        "disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-expense",
        className,
      )}
      {...props}
    />
  );
}
